module.exports = __webpack_public_path__ + "img/bg_ellipse_01.60c35cb.png";